// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, forgotPassword } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitForgotPasswordApi = createAsyncThunk(
  "hitForgotPasswordApi",
  async (payload) => {
    try {
   
      const url = ApiBaseUrl + forgotPassword;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
     // toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const ForgotPasswordSlice = createSlice({
  name: "forgotPasswordReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearForgotPasswordData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitForgotPasswordApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitForgotPasswordApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitForgotPasswordApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearForgotPasswordData } = ForgotPasswordSlice.actions;
export default ForgotPasswordSlice.reducer;